import { localize, extend } from 'vee-validate';
import { required, min_value as minValue, max_value as maxValue, min, max, email, numeric } from 'vee-validate/dist/rules';
import { isEmpty, chain, size, get } from 'lodash';
import ko from 'vee-validate/dist/locale/ko.json';

// [참고] 기본 메시지 양식
// https://github.com/logaretm/vee-validate/blob/master/locale/ko.json

localize('ko', ko);
extend('required', {
  ...required,
  message: '{_field_} 항목은 필수 정보입니다.',
});

extend('minValue', {
  ...minValue,
  message: '{_field_}항목의 값은 {min} 이상으로 입력해 주세요.',
});

extend('maxValue', {
  ...maxValue,
  message: '{_field_}항목의 값은 {max} 이하로 입력해 주세요.',
});

extend('min', {
  ...min,
  message: '{_field_}항목의 값은 최소 {length}글자로 입력해 주세요.',
});

extend('max', {
  ...max,
  message: '{_field_}항목의 값은 최대 {length}글자로 입력해 주세요.',
});

extend('email', {
  ...email,
  message: '{_field_}항목의 값은 유효한 이메일 형식이어야 합니다',
});

extend('numeric', {
  ...numeric,
  message: '{_field_}항목에는 숫자만 사용 가능합니다.',
});

export const hasError = (errors, name) => size(get(errors, name, [])) > 0;

export const getFirstErrorMessage = (validator, defaultText) => {
  const errorText = chain(validator.errors).values().flatten().head().value();
  return isEmpty(errorText) ? isEmpty(defaultText) ? '필수 정보를 입력 해주세요.' : defaultText : errorText;
};

export { ValidationProvider, ValidationObserver } from 'vee-validate';
